// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"839":"541a511a","889":"6733de99"}[chunkId] + ".chunk.css";
};